<!-- 折线图 -->
<template>

  <div>
      <div class="chart_Title" style="width:100%;align-items: center;" :style = "{ background: 'url(' +commenUrl+ baseConfig.title?.textRgb + ') no-repeat',backgroundSize:'100%',display:baseConfig?.title?.textShow?'flex':'none', height: baseConfig.title?.Height + 'px'}">
          <div class="img-icon" :style = "{ width: baseConfig.title?.textWidth + 'px', height: baseConfig.title?.textHeight + 'px', marginLeft: baseConfig.title?.textLeft + 'px', marginRight: baseConfig.title?.textRight + 'px',display:baseConfig?.title?.textIcon?'block':'none'}">
              <img style="height:100%;width:100%" :src="commenUrl+baseConfig?.title?.textIcon" alt="">
          </div>
          <div style="flex:1" :style = "{ fontSize: baseConfig.title?.textSzie + 'px', color: baseConfig.title?.textColor,textAlign: baseConfig.title?.textAlign}">{{baseConfig?.title?.textTitle}}</div>
      </div>
      <div class="linebox" id='linebox' :class="baseConfig.animation"  :style = "{ width: baseConfig.width + 'px', height: baseConfig.height + 'px'}">
        <div  class="chartLine" ref='BlinechartRef' :style = "{ left: baseConfig.left + 'px',top: baseConfig.top + 'px'}"></div>
      </div>
    </div>

</template>


<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import { colorCustomMerge, cloneDeep  } from '../../../utils'
import * as echarts from 'echarts';
import { useStore } from 'vuex';
export default {
  props: {
      index: {
          type:Number ,
          default: function () { return {} }
      },
      yearRef:{
          type: String,
          default: function () { return "2024" }
      }
  },
  setup(props) {
     
      const { proxy } = getCurrentInstance();
      const store = useStore();
      const index = ref(props.index);
      const canvasConfig = ref(computed(() => store.state.chartData.canvasConfig));
      const comChartColors = ref(colorCustomMerge())   //获取选中颜色
      const baseConfig = ref({})
      const componentList = ref(computed(() => store.state.chartData.componentList));
      baseConfig.value = componentList.value[index.value].config.baseConfig
      const option = ref({})
      const BlinechartRef = shallowRef(null);
      const chartInstance = shallowRef(null);
      const handleResize = () => {
          chartInstance.value.resize();
      };
      watch(() => store.state.chartData.componentList[index.value].config.options,(newVal, oldVal) => {
          //此时返回的是数组,按下标获取对应值
              if(newVal){
                  chartInit()
              }
          },{ deep: true }
      ) 
      watch(() => store.state.chartData.componentList[index.value].data,(newVal, oldVal) => {
            //此时返回的是数组,按下标获取对应值
              if(newVal){
                  chartInit()
              }
          },{ deep: true }
      )
      watch(() => store.state.chartData.componentList[index.value].config.baseConfig,(newVal, oldVal) => {
          //此时返回的是数组,按下标获取对应值
              if(newVal){
                baseConfig.value = componentList.value[index.value].config.baseConfig
                setTimeout(()=>{
                  handleResize()
                })
              }
          },{ deep: true }
      ) 
      onMounted(() => {
          chartInstance.value = echarts.init(BlinechartRef.value);
          chartInit() 
          window.addEventListener('resize', handleResize);
      });
      onUnmounted(() => {
          window.removeEventListener('resize', handleResize);
      });

      const chartInit = ()=>{
        chartInstance.value.clear()
        option.value = componentList.value[index.value].config.options
        option.value.legend.data = componentList.value[index.value].data.legendData
        option.value.xAxis.data = componentList.value[index.value].data.labelist
        let dwList = componentList.value[index.value].data.dwList
        let  opacity = 1
        if(option.value.contorlsoption.mjDj){
          opacity = 1
        }else{
          opacity = 0
        }
        let series = componentList.value[index.value].data.valueList.map((item,index) =>{
           return {
            name: option.value.legend.data[index],
            data: item,
            type: "line",
            lineStyle: {
                width: option.value.contorlsoption.lineWidth // 线宽
            },
            smooth:option.value.contorlsoption.smooth,//是否设置为圆滑的曲线
            symbol:option.value.contorlsoption.symbol,//
            symbolSize: option.value.contorlsoption.symbolSize,//曲线上面的圆点大小
            areaStyle: { //区域填充样式
                opacity:opacity,
                color: new echarts.graphic.LinearGradient(0,0,0,1,
                    [{ offset: 0, color: option.value.color[index]+'48',},
                    { offset: 0.7, color: option.value.color[index]+'00' },],
                    false
                ),
            },
            shadowColor: "rgba(61,234,255, 0.9)", //阴影颜色
            tooltip:{
              valueFormatter: (value) => {
                if(value){
                  return value + dwList[index]//+'元/斤'
                }else{
                  return ''
                }           
              }
            }
          }; 
        })
        option.value.series = series
        chartInstance.value.setOption(option.value);
      }
      
      return{
          option,
          BlinechartRef,
          baseConfig,
          canvasConfig,
          comChartColors

      }
  }
}
</script>

<style scoped>
.linebox {position: relative;}
.chartLine {
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>



